module.exports = __webpack_public_path__ + "media/images/web_suite/resources_thumbs/featured-learn-site-thumbnail_es-7dd9cae621c20442a69f787801b25e75.png";